import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set) => ({
      usuario: null,
      accessToken: null,
      refreshToken: null,
      setSession: ({ usuario, accessToken, refreshToken }) => set({
        usuario,
        accessToken,
        refreshToken
      }),
      renovarTokens: ({ accessToken, refreshToken }) => set({
        accessToken,
        refreshToken
      }),
      atualizarUsuario: (atualizacoes) => set(state => ({
        usuario: state.usuario ? { ...state.usuario, ...atualizacoes } : null
      })),
      adicionarInstituicao: (vinculo) => set(state => ({
        usuario: state.usuario ? {
          ...state.usuario,
          instituicoes: [
            ...(state.usuario.instituicoes || []).filter(item => item.instituicao?.id !== vinculo.instituicao?.id),
            vinculo
          ]
        } : null
      })),
      logout: () => set({
        usuario: null,
        accessToken: null,
        refreshToken: null
      })
    }),
    { name: 'eduplex-auth' }
  )
)
